import { useEffect, useState } from 'react';
import { RoomEvents, RoomStatuses } from 'screens/TelehealthScreen/utils/enums';
import { useVideoContext } from 'screens/TelehealthScreen/hooks';

export default function useRoomState() {
  const { room } = useVideoContext();
  const [state, setState] = useState(RoomStatuses.Disconnected);

  useEffect(() => {
    if (room) {
      const setRoomState = () => setState(room.state as RoomStatuses);

      setRoomState();

      room
        .on(RoomEvents.Disconnected, setRoomState)
        .on(RoomEvents.Reconnected, setRoomState)
        .on(RoomEvents.Reconnecting, setRoomState);

      return () => {
        room
          .off(RoomEvents.Disconnected, setRoomState)
          .off(RoomEvents.Reconnected, setRoomState)
          .off(RoomEvents.Reconnecting, setRoomState);
      };
    }
  }, [room]);

  return state;
}
